import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
    // ✅ 关键修改：去掉域名和端口，只保留 /api 前缀（或完全省略）
    baseURL: '/api', // 所有请求自动相对于当前域名（https://services.fastcoy.com）
    timeout: 5000
})

// 请求拦截器（可选）
service.interceptors.request.use(
    config => {
        // 可在这里添加 token
        // config.headers['Authorization'] = 'Bearer ' + getToken()
        return config
    },
    error => {
        console.log(error)
        return Promise.reject(error)
    }
)

// 响应拦截器（统一处理错误）
service.interceptors.response.use(
    response => {
        const res = response.data
        // 假设后端返回格式：{ success: true, data: [...] }
        if (res.success) {
            return res.data
        } else {
            console.error('API Error:', res.message)
            return Promise.reject(new Error(res.message || 'Error'))
        }
    },
    error => {
        console.error('请求失败，Request failed:', error)
        // alert('请求失败，请稍后再试')
        return Promise.reject(error)
    }
)

export default service